import api from './api';
import { Feast, PaginatedResponse } from '../types';
export interface FeastFilters { page?: number; limit?: number; search?: string; }
const feastsService = {
  getList: async (filters: FeastFilters = {}): Promise<PaginatedResponse<Feast>> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    return (await api.get(`/feasts?${params.toString()}`)).data;
  },
  getById: async (id: number): Promise<Feast> => (await api.get(`/feasts/${id}`)).data.data,
  create: async (data: any): Promise<Feast> => (await api.post('/feasts', data)).data.data,
  update: async (id: number, data: any): Promise<Feast> => (await api.put(`/feasts/${id}`, data)).data.data,
  delete: async (id: number): Promise<void> => { await api.delete(`/feasts/${id}`); },
};
export default feastsService;
